import React from 'react';
import PropTypes from 'prop-types';
import {AspectRatioCardImage} from '@homeaway/react-aspect-ratio-card';
import {Placeholder} from '../PlaceholderCard';

import {
    SHORT_CAROUSEL_ASPECT_RATIO,
    TALL_CAROUSEL_ASPECT_RATIO,
    CAROUSEL_ASPECT_RATIO_16X9,
    CAROUSEL_ASPECT_RATIO_3X2,
    CAROUSEL_ASPECT_RATIO_1X1,
} from '../../common/constants';

const CardImage = ({
    imageOverlay,
    imageUri,
    aspectRatio,
    loadImage,
    svgIcon,
    alt,
}) => {
    if (!imageUri || !loadImage) {
        return <Placeholder svgIcon={svgIcon} />;
    }

    return (
        <React.Fragment>
            <AspectRatioCardImage
                imageUri={imageUri}
                aspectRatio={aspectRatio}
                alt={alt}
            />
            {imageOverlay}
        </React.Fragment>
    );
};

CardImage.propTypes = {
    /** The image alt */
    alt: PropTypes.string,
    /** Value to determine whether to use a short or a tall card */
    aspectRatio: PropTypes.oneOf([
        TALL_CAROUSEL_ASPECT_RATIO,
        SHORT_CAROUSEL_ASPECT_RATIO,
        CAROUSEL_ASPECT_RATIO_16X9,
        CAROUSEL_ASPECT_RATIO_3X2,
        CAROUSEL_ASPECT_RATIO_1X1,
    ]),
    /** An image overlay component instance */
    imageOverlay: PropTypes.node,
    /** The image source url */
    imageUri: PropTypes.string,
    /** Whether to show the image (used for lazy loading) */
    loadImage: PropTypes.bool,
};

export default CardImage;
